<div class="modal-header">
  <h4 class="modal-title">Email</h4>
  <button type="button" class="close" aria-label="Close" (click)="activeModal.dismiss()">
    <span aria-hidden="true">&times;</span>
  </button>
</div>

<div class="modal-body">
  <div class="alert alert-info" role="alert" *ngIf="loading">
    Loading...
  </div>

  <div class="alert alert-danger" role="alert" *ngIf="errorMessage">
    {{ errorMessage }}
  </div>

  <ng-container *ngIf="!loading && !errorMessage && email">
    <dl class="row mb-0">
      <dt class="col-sm-3">Date / Time</dt>
      <dd class="col-sm-9">
        {{ dateStringFromISO8601(email.created_at) }},
        {{ timeStringFromISO8601(email.created_at) }}
      </dd>

      <dt class="col-sm-3">From</dt>
      <dd class="col-sm-9">{{ email.from_email }}</dd>

      <dt class="col-sm-3">To</dt>
      <dd class="col-sm-9">{{ email.to_emails.join(', ') }}</dd>

      <ng-container *ngIf="email.cc_emails.length > 0">
        <dt class="col-sm-3">Cc</dt>
        <dd class="col-sm-9">{{ email.cc_emails.join(', ') }}</dd>
      </ng-container>

      <ng-container *ngIf="email.bcc_emails.length > 0">
        <dt class="col-sm-3">Bcc</dt>
        <dd class="col-sm-9">{{ email.bcc_emails.join(', ') }}</dd>
      </ng-container>

      <ng-container *ngIf="email.reply_to.length > 0">
        <dt class="col-sm-3">Reply-To</dt>
        <dd class="col-sm-9">{{ email.reply_to.join(', ') }}</dd>
      </ng-container>

      <dt class="col-sm-3">Subject</dt>
      <dd class="col-sm-9">{{ email.subject }}</dd>
    </dl>

    <hr>

    <app-isolated-html [content]="htmlContent"></app-isolated-html>
  </ng-container>
</div>

<div class="modal-footer">
  <button type="button" class="btn btn-secondary"
          (click)="activeModal.close()">
    Close
  </button>
</div>
